import type { Language } from '@/redux/common'
import cookie from 'react-cookies';
/**
 * @description: 获取cookie中的语言设置
 * @param {*} 
 * @return {*}
 */
export const getLanguage = ():Language => {
  const langType:any = {
    zh: 'zh',
    'zh-cn': 'zh',
    'zh-hk': 'zh',
    'zh-tw': 'zh',
    en: 'en',
    'en-us': 'en',
    default: 'zh'
  };
  const { pathname } = window.location
  const reg = /^\/(zh|en)($|\/|\?)/
  if (reg.test(pathname)) {
    const lang = pathname.split('/')[1]
    handleChangeLanguage(langType[lang] || langType.default);
  }
  const lang = cookie.load('lang') || window.navigator.language || 'en';
  return langType[lang.toLowerCase()] || langType.default;
};



export function handleChangeLanguage(value: any) {
  console.log(value)
  // 判断是否在测试环境或者是线上环境
  const langObj:any = {
    'en': 'en-US',
    'zh': 'zh-CN'
  };
  if (window.location.href.includes('.originqc.com')) {
    if (window.location.href.includes('.originqc.com.cn')) {
      // 线上环境
      cookie.save('lang', langObj[value], {path: '/', domain: '.originqc.com.cn'});
    } else {
      // 测试环境
      cookie.save('lang', langObj[value], {path: '/', domain: '.originqc.com'});
    }
  } else {
    // 本地环境
    cookie.save('lang', langObj[value], { path: '/' });
  }
}

// 深复制方法类型声明
export type DeepCloneType = (...ages: any) => any;

/**
 * @description: 深拷贝
 * @param {any} target 要拷贝的对象
 * @param {*} hash 哈希方式
 * @return {any} 拷贝后的对象
 */
 export const deepClone: DeepCloneType = (target, hash = new WeakMap()) => {
  // 如果是 null 就不进行拷贝操作
  if (target === null) {
      return target
  }
  // 日期对象直接返回一个新的日期对象
  if (target instanceof Date){
   return new Date(target);
  } 
  //正则对象直接返回一个新的正则对象     
  if (target instanceof RegExp){
   return new RegExp(target);     
  }
  // 处理 DOM元素
  if (target instanceof HTMLElement) {
      return target
  }
  // 处理原始类型和函数 不需要深拷贝，直接返回
  if (typeof target !== 'object') {
      return target 
  }
  
  //如果循环引用,就用 weakMap 来解决
  if (hash.has(target)){
   return hash.get(target);
  }
  // 获取对象所有自身属性的描述
  // const allDesc = Object.getOwnPropertyDescriptors(obj);
  // const cloneObj = Object.create(Object.getPrototypeOf(obj), allDesc)
  
  // eslint-disable-next-line
  const cloneTarget = new (target as any).constructor()
  
  type KEYTYPE = keyof typeof target
  for (const key of Reflect.ownKeys(target as unknown as Record<string, unknown>)) { 
    if(typeof target[key as KEYTYPE] === 'object' && target[key as KEYTYPE] !== null){
      cloneTarget[key] = deepClone(target[key as KEYTYPE], hash);
    } else {
      cloneTarget[key] = target[key as KEYTYPE];
    }
  }
  return cloneTarget
}
export const setLanguage = (lang: Language) => {
  handleChangeLanguage(lang);
  const { origin, search, hash } = window.location
  let { pathname } = window.location
  pathname = pathname.replace(/\/zh|\/en/, `/${lang}`)
  window.location.href = origin + pathname + search + hash
}


/**
 * @description 时间戳格式化
 * @param {*} formater
 * @param {*} t
 * @returns
 * @example //dateFormater('YYYY-MM-DD HH:mm', t) ==> 2019-06-26 18:30  dateFormater('YYYY-MM-DD HH:mm:ss', t) ==> 2019-06-26 18:30:36
 */
export const dateFormater = (formater: string, t: number) => {
  const date = t ? new Date(t) : new Date(),
    Y = date.getFullYear() + '',
    M = date.getMonth() + 1,
    D = date.getDate(),
    H = date.getHours(),
    m = date.getMinutes(),
    s = date.getSeconds();
  return formater
    .replace(/YYYY|yyyy/g, Y)
    .replace(/YY|yy/g, Y.substring(2, 4))
    .replace(/MM/g, (M < 10 ? '0' : '') + M)
    .replace(/DD/g, (D < 10 ? '0' : '') + D)
    .replace(/HH|hh/g, (H < 10 ? '0' : '') + H)
    .replace(/mm/g, (m < 10 ? '0' : '') + m)
    .replace(/ss/g, (s < 10 ? '0' : '') + s);
};


/**
 * @description: 诸葛主动埋点事件
 * @param {*} eventName 事件名称
 * @param {*} params 自定义属性
 * @param {*} callback 回调函数
 * @return {*}
 */
export const zhugeTrack = (eventName: string, params: Record<any, any> = {}, callback?: () => void) => {
  const commonParams = {
    'productName': '量子云',
    'client': 'pc端'
  };
  if (window.zhuge) {
    window.zhuge.track(eventName, {...commonParams, ...params}, () => {
      callback && callback();
    });
  } else {
    callback && callback();
  }
};

